import {
	pricingMethods,
	months,
	PciVendorTypes,
	UserStatuses,
	HighRiskType,
} from "models";

export const staticDropdownValuesService = {
	getUserStatuses,
	getPricingMethods,
	getMonths,
	getMonthsForHookForm,
	getFeeMonths,
	getFeePrograms,
	getPciVendorType,
	getPciNonComplianceFees,
	getApplicationStatuses,
	getHighRiskType,
};

function getUserStatuses() {
	return Promise.resolve(UserStatuses);
}

function getPricingMethods() {
	return Promise.resolve(Object.values(pricingMethods));
}

function getMonths() {
	return Promise.resolve(Object.values(months));
}

function getMonthsForHookForm() {
	return Promise.resolve(
		Object.values(
			months.map(({ name, value }) => ({
				displayName: name,
				name: value,
			})),
		),
	);
}

function getFeeMonths() {
	return Promise.resolve([
		{ name: "January", value: "Jan" },
		{ name: "February", value: "Feb" },
		{ name: "March", value: "Mar" },
		{ name: "April", value: "Apr" },
		{ name: "May", value: "May" },
		{ name: "June", value: "Jun" },
		{ name: "July", value: "Jul" },
		{ name: "August", value: "Aug" },
		{ name: "September", value: "Sep" },
		{ name: "October", value: "Oct" },
		{ name: "November", value: "Nov" },
		{ name: "December", value: "Dec" },
	]);
}

function getFeePrograms() {
	return Promise.resolve([
		{ name: "Interchange Plus", value: "InterchangePlus" },
		{ name: "Flat Rate", value: "FlatRate" },
		{ name: "Three Tier", value: "ThreeTier" },
		{ name: "ERR", value: "ERR" },
		{ name: "Dual Flat Rate Pricing", value: "DualFlatRate" },
	]);
}

function getPciVendorType() {
	return Promise.resolve(PciVendorTypes);
}

function getHighRiskType() {
	return Promise.resolve(HighRiskType);
}

function getPciNonComplianceFees() {
	return Promise.resolve([
		{ value: "0.000000", name: "0.00" },
		{ value: "19.950000", name: "19.95" },
		{ value: "30.000000", name: "30.00" },
		{ value: "33.950000", name: "33.95" },
		{ value: "50.000000", name: "50.00" },
		{ value: "75.000000", name: "75.00" },
	]);
}

function getApplicationStatuses() {
	return Promise.resolve([
		{
			name: "Submitted",
			subStatuses: [
				{ name: "In Progress", parentStatusId: 4, id: 1 },
				{ name: "Failed", parentStatusId: 4, id: 3 },
				{ name: "Waiting for Signature", parentStatusId: 4, id: 2 },
			],
			id: 4,
		},
		{
			name: "Boarding",
			subStatuses: [
				{ name: "Rejected", parentStatusId: 14, id: 14 },
				{ name: "Unassigned", parentStatusId: 14, id: 11 },
				{ name: "In Progress", parentStatusId: 14, id: 12 },
			],
			id: 14,
		},
		{
			name: "Pre-Application",
			subStatuses: [
				{ name: "Link Sent", parentStatusId: 22, id: 30 },
				{ name: "Pending Completion", parentStatusId: 22, id: 22 },
			],
			id: 22,
		},
		{
			name: "Signed MPA",
			subStatuses: [],
			id: 29,
		},
		{ name: "Draft", subStatuses: [], id: 20 },
		{
			name: "Underwriting",
			subStatuses: [
				{ name: "Unassigned", parentStatusId: 51, id: 4 },
				{ name: "In review", parentStatusId: 51, id: 5 },
				{ name: "Declined", parentStatusId: 51, id: 10 },
			],
			id: 51,
		},
		{
			name: "TID & Equipment request",
			subStatuses: [
				{ name: "Unassigned", parentStatusId: 57, id: 24 },
				{ name: "In Progress", parentStatusId: 57, id: 25 },
			],
			id: 57,
		},
		{
			name: "Installation request",
			subStatuses: [
				{ name: "Unassigned", parentStatusId: 58, id: 26 },
				{ name: "In Progress", parentStatusId: 58, id: 27 },
			],
			id: 58,
		},
		{
			name: "Completed",
			subStatuses: [],
			id: 28,
		},
	]);
}
